import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Mail } from 'lucide-react';

export const Route = createFileRoute('/admin-console/monitoring/email-activity')({
    staticData: {
        breadcrumb: {
            title: 'Email activity',
            inactive: true,
        },
        ui: {
            icon: Mail,
            menuDescription: 'Email delivery tracking',
        },
    },
    component: Outlet,
});
